import { Link } from "react-router-dom";
import { motion } from "framer-motion";

/**
 * Single program card in the Programs grid — image, title, blurb, "Learn more →".
 * Stagger animation is keyed off `index`.
 */
export default function ProgramCard({ program, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, delay: index * 0.05, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to={`/programs/${program.slug}`}
        data-testid={`program-card-${program.slug}`}
        className="premium-card group flex flex-col h-full overflow-hidden rounded-2xl border-2 border-border hover:border-primary/55 bg-background shadow-md hover:shadow-xl transition-all"
      >
        <div className="aspect-[4/3] overflow-hidden">
          <img
            src={program.image}
            alt={`${program.title} — Integrated Clinical Intelligence program`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            loading="lazy"
            style={{ filter: "brightness(1.05) contrast(1.05) saturate(1.1)" }}
          />
        </div>
        <div className="p-6 flex flex-col flex-1">
          <h3 className="font-display text-xl md:text-2xl font-semibold tracking-tight">
            {program.title}
          </h3>
          <p className="mt-2 text-base text-foreground/75 leading-relaxed flex-1">
            {program.blurb}
          </p>
          <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary group-hover:gap-2.5 transition-all">
            Learn more <span aria-hidden>→</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
